import { render, staticRenderFns } from "./FactionIcon.vue?vue&type=template&id=54a5afda&scoped=true&"
import script from "./FactionIcon.vue?vue&type=script&lang=js&"
export * from "./FactionIcon.vue?vue&type=script&lang=js&"
import style0 from "./FactionIcon.vue?vue&type=style&index=0&id=54a5afda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5afda",
  null
  
)

export default component.exports